import {
    Stack,
    Grid,
    Typography,
    TextField,
    Checkbox,
    InputAdornment,
    IconButton,
    Link, 
    Select,
    MenuItem,
    InputLabel,
    FormControlLabel  
  } from '@mui/material';
  import { LoadingButton } from '@mui/lab';
  import { useCallback, useEffect, useState } from 'react';
  import Image from 'src/components/image';
  import PropTypes from 'prop-types';
  import Iconify from 'src/components/iconify';
  import TermsAndPolicy from 'src/sections/terms-and-privacy';
  import { useResponsive } from 'src/hooks/use-responsive';

  export default function PersonalDetailsView({
    name,
    password,
    phoneCountryCode,
    phoneNo,
    designation,
    formErrors,
    isChecked,
    setIsChecked,
    setName,
    setPassword,
    setPhoneCountryCode,
    setPhoneNo,
    setDesignation,
    isSubmitting,
    setIsSubmitting,
    handleOnClick,
    handleGoBack,
    }) {
     const countryCodes = [
      { code: 'US/CA', label: '+1' },
      { code: 'GB', label: '+44' },
      { code: 'India', label: '+91' },
    ];
    const [showPass,setShowPass]=useState(false);

    return (
        <Grid container justifyContent="center" sx={{ paddingX: 2, maxWidth:'600px' ,paddingY:0}}>
          <Grid item xs={12} md={6} >
              <Stack spacing={1} >
                <Typography variant="h2" >Personal Details</Typography>
                <InputLabel id="country-label" sx={{marginTop:'20px', color:'black',fontWeight:500}}>Name</InputLabel>
                <TextField
                  variant="outlined"
                  fullWidth
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  error={!!formErrors?.name}
                  helperText={formErrors?.name}
                />
                <InputLabel id="phone-label" sx={{ marginTop: '20px', color: 'black', fontWeight: 500 }}>Phone Number</InputLabel>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Select
                    labelId="country-code-label"
                    id="country-code"
                    sx={{ width: 56 }}
                    value={phoneCountryCode}
                    onChange={(e) => setPhoneCountryCode(e.target.value)}
                    error={!!formErrors?.phoneCountryCode}
                    helperText={formErrors?.phoneCountryCode}
                    required
                  >
                    {countryCodes.map((country) => (
                      <MenuItem key={country.label} value={country.label}>
                        {country.label}
                      </MenuItem>
                    ))}
                  </Select>
                  <TextField
                    variant="outlined"
                    fullWidth
                    value={phoneNo}
                    onChange={(e) => setPhoneNo(e.target.value)}
                    required
                    error={!!formErrors?.phoneNo}
                    helperText={formErrors?.phoneNo}
                  />
                </Stack>
                <InputLabel id="country-label" sx={{marginTop:'20px', color:'black',fontWeight:500}}>Designation</InputLabel>
                <TextField
                  variant="outlined"
                  fullWidth
                  value={designation}
                  onChange={(e) => setDesignation(e.target.value)}
                  required
                  error={!!formErrors?.designation}
                  helperText={formErrors?.designation}
                />
                <InputLabel id="country-label" sx={{marginTop:'20px', color:'black',fontWeight:500}}>Create Password</InputLabel>
                <TextField
                  variant="outlined"
                  fullWidth
                  value={password}
                  type={showPass ? 'text' : 'password'}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  error={!!formErrors?.password}
                  helperText={formErrors?.password}
                  InputProps={{
                    endAdornment: (
                    <InputAdornment position="end">
                        <IconButton onClick={() => setShowPass(!showPass)} edge="end">
                        <Iconify
                            icon={showPass? 'ooui:eye' : 'formkit:eyeclosed'}
                        />
                        </IconButton>
                    </InputAdornment>
                    ),
                }}
                />
                <Stack direction="row" spacing={2} justifyContent="start" alignItems="center" width="100%" my={2}>
                    <Checkbox defaultChecked={isChecked} onChange={(e)=> setIsChecked(event.target.checked)}/>
                    <InputLabel error={!!formErrors?.isChecked}>
                        I agree to <a rel="nofollow" className="purpleText" href="https://hireintel.app/terms.html" target="_blank">Terms and Conditions</a>
                    </InputLabel>
                </Stack>
                {/* <Stack direction="row" spacing={2} justifyContent="center" alignItems="center" width="100%"> */}
                    {/* <LoadingButton
                        type="button"
                        variant="contained"
                        fullWidth
                        loading={isLoading}
                        onClick={handleGoBack}
                        required
                    >
                        Go Back
                    </LoadingButton> */}
                    <LoadingButton
                        type="submit"
                        variant="contained"
                        fullWidth
                        loading={isSubmitting}
                        onClick={handleOnClick}
                        required
                    >
                        Create Account
                    </LoadingButton>
                    {/* </Stack> */}
              </Stack>
          </Grid>
        </Grid>
      );
  }